// Display constants for the Support pages; tickets come from /api/admin/support

// Key order is the order options appear in the filters
export const TICKET_STATUS = {
  open: { label: "Open", tone: "danger" },
  inProgress: { label: "In progress", tone: "warning" },
  waiting: { label: "Waiting on trader", tone: "warning" },
  resolved: { label: "Resolved", tone: "success" },
};

// The categories traders pick from in the portal's report form
export const TICKET_CATEGORIES = {
  portfolio: "Portfolio",
  leaderboard: "Leaderboard",
  referrals: "Referrals",
  kyc: "KYC",
  withdrawals: "Withdrawals",
  other: "Other",
};

export const TICKET_PRIORITIES = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const TICKET_AGES = {
  under4h: "Under 4h",
  under24h: "4h – 24h",
  over24h: "Over 24h",
};

const HOUR_MS = 60 * 60 * 1000;

// The age bucket a ticket submitted at `createdAt` falls in
export function ticketAge(createdAt, now = Date.now()) {
  const age = now - new Date(createdAt).getTime();
  return age < 4 * HOUR_MS ? "under4h" : age < 24 * HOUR_MS ? "under24h" : "over24h";
}

// The queue's overview cards, from the `stats` of GET /api/admin/support/tickets
export const SUPPORT_STATS = [
  { key: "openTickets", label: "Open tickets" },
  { key: "awaitingResponse", label: "Awaiting response" },
  { key: "waitingOnTrader", label: "Waiting on trader" },
  { key: "highPriority", label: "High priority" },
  { key: "resolvedToday", label: "Resolved today" },
  { key: "avgFirstResponseMinutes", label: "Average first response", unit: "min" },
];

// Files the API accepts on a reply (it checks again, and S3 enforces the size)
export const ATTACHMENT_ACCEPT = "image/png,image/jpeg,image/gif,image/webp,application/pdf,text/plain,text/csv";
export const ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
